import React, { useEffect } from "react";
// import IrregularitiesPage from "../../../Irregularities";
import BouncedChequesPage from "../../../BouncedCheques";
import { useDispatch, useSelector } from "react-redux";
// import { setIrregularitiesDetails, setIrregularitiesLoading, setIrregularitiesError } from "../../../../../store/reducers/slices/irregularities.slice";
import { setBouncedChequesDetails, setBouncedChequesLoading, setBouncedChequesError } from "../../../../../store/reducers/slices/bouncedcheques.slice";
// import { Irregularities } from "../../../../../utils/JsonData/irregularities";
// import { getIrregularities } from "../../../../../api/Irregularities";
import { getBouncedCheques } from "../../../../../api/BouncedCheques";

const BouncedCheques = () => {
    const dispatch = useDispatch();
    const { bouncedchequesDetails } = useSelector(({ bouncedcheques }) => bouncedcheques);
    const { reportDetails, selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);
    console.log("BOUNCED CHEQUE DETAIL:", bouncedchequesDetails);

    // API and redux
    useEffect(() => {
        //   dispatch(setBouncedChequesLoading(true));
        // if (!irregularitiesDetails) {
        //     dispatch(setIrregularitiesDetails(Irregularities));
        // }
        // dispatch(setIrregularitiesLoading(false));
        const fetchData = async () => {
            try {
                let aggregate = selectedAccountId !== 'all'? false : true;
                let account_id = selectedAccountId !== 'all'? selectedAccountId : reportDetails?.report?.reportId;
                const response = await getBouncedCheques(account_id, aggregate);
                dispatch(setBouncedChequesDetails(response));
                dispatch(setBouncedChequesLoading(false));
            } catch (error) {
                dispatch(setBouncedChequesLoading(false));
                dispatch(setBouncedChequesError(error.message));
                console.log("ERROR", error);
            }
        }

        if (selectedAccountId) {
            fetchData();
        }
        // else {
        //       dispatch(setBouncedChequesLoading(false));
        //   }
    }, [selectedAccountId])
    return (
        <BouncedChequesPage />
    )
}

export default BouncedCheques